import { render, staticRenderFns } from "./AssetInformationCreateClassification.vue?vue&type=template&id=1930f015&scoped=true&"
import script from "./AssetInformationCreateClassification.vue?vue&type=script&lang=js&"
export * from "./AssetInformationCreateClassification.vue?vue&type=script&lang=js&"
import style0 from "./AssetInformationCreateClassification.vue?vue&type=style&index=0&id=1930f015&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1930f015",
  null
  
)

export default component.exports